import React, { Fragment, useState, useEffect } from 'react';
import CustomTable from '@jumbo/components/CustomTable';
import PageLoader from '@jumbo/components/custom/Spinner/pageLoader';
import VerReclamo from '../../AppComponentsNUtils/ModalVerReclamo';
import QuitReclamo from '../../AppComponentsNUtils/QuitReclamo';
import Spinner from '@jumbo/components/custom/Spinner';
import { validacionPermit } from '../../../../../services/service.user';
import { CustomToast } from '@jumbo/components/custom/Toast';
import {
  getDatosEntidadesList,
  tableHeadCells,
  validaciones,
  misAsignacionesActions,
} from '../../AppComponentsNUtils/SeguimientoReclamosUtils';
import { getReclamosAutoasignadosIf } from 'services/api';
import ModalProrroga from '../../AppComponentsNUtils/ModalProrroga';
import AddAntecedente from '../../AppComponentsNUtils/AddAntecedente';
import RenderFile from 'customComponents/RenderFile';

const TablaReclamosPendientes = () => {
  const [primeraCarga, setPrimeraCarga] = useState(false);
  const [entidadesList, setEntidadesList] = useState([]);
  const [showVerReclamo, setShowVerReclamo] = useState(false);
  const [reclamoVer, setReclamoVer] = useState(null);
  const [showQuitarReclamo, setShowQuitarReclamo] = useState(false);
  const [reclamoQuitar, setReclamoQuitar] = useState(null);
  const [spinner, setSpinner] = useState(false);

  const [showProrroga, setShowProrroga] = useState(false);
  const [reclamoProrroga, setReclamoProrroga] = useState(null);

  const [showAddAnt, setShowAddAnt] = useState(false);
  const [reclamoAddAnt, setrReclamoAddAnt] = useState(null);

  const [url, setUrl] = useState(undefined);
  const [urlSuper, setUrlSuper] = useState(undefined);

  const [showPreview, setShowPreview] = useState(false);
  const [showPreviewSuper, setShowPreviewSuper] = useState(false);
  const [reload, setReload] = useState(false);

  const loadData = () => {
    setSpinner(true);
    getReclamosAutoasignadosIf()
      .then(res => {
        setEntidadesList(
          res.data.map(entidad => {
            return getDatosEntidadesList(entidad);
          }),
        );
        setPrimeraCarga(true);
      })
      .catch(err => {
        console.log(err);
      })
      .finally(res => {
        setSpinner(false);
      });
  };

  useEffect(() => {
    loadData();
  }, [reload]);

  const handleAction = (menu, item) => {
    if (menu.action === 'ver') {
      setReclamoVer(item);
      setShowVerReclamo(true);
    } else if (menu.action === 'quitar') {
      setReclamoQuitar(item);
      setShowQuitarReclamo(true);
    } else if (menu.action === 'prorroga') {
      setReclamoProrroga(item);
      setShowProrroga(true);
    } else if (menu.action === 'addAnt') {
      setrReclamoAddAnt(item);
      setShowAddAnt(true);
    }
  };

  const openModal = fila => {
    setReclamoVer(fila);
    setShowVerReclamo(true);
  };

  const verReclamoClose = () => {
    setShowVerReclamo(false);
    setReclamoVer(null);
  };

  const quitarReclamoClose = () => {
    setShowQuitarReclamo(false);
    setReclamoQuitar(null);
  };

  const quitarReclamoSubmit = () => {
    setShowQuitarReclamo(false);
    setReclamoQuitar(null);
    loadData();
  };

  const closeModalProrroga = () => {
    setShowProrroga(false);
    setReclamoProrroga(null);
  };

  const AddAntClose = () => {
    setrReclamoAddAnt(null);
    setShowAddAnt(false);
  };

  const closePreview = () => {
    setShowPreview(false);
    setUrl('');
  };

  const cargarUrl = url => {
    setUrl(url);
    setShowPreview(true);
  };

  const closePreviewSuper = () => {
    setShowPreviewSuper(false);
    setUrlSuper('');
  };
  const cargarUrlSuper = url => {
    setUrlSuper(url);
    setShowPreviewSuper(true);
  };

  return (
    validacionPermit('search_reclaim_if') && (
      <Fragment>
        <Spinner show={spinner} />
        <CustomToast />
        <VerReclamo
          openDialog={showVerReclamo}
          close={verReclamoClose}
          reclamo={reclamoVer}
          cargarPreview={cargarUrl}
          cargarPreviewSuper={cargarUrlSuper}
        />
        <AddAntecedente
          openDialog={showAddAnt}
          close={AddAntClose}
          reclamo={reclamoAddAnt}
          cargarPreview={cargarUrl}
          cargarPreviewSuper={cargarUrlSuper}
          setReload={setReload}
          reload={reload}
        />
        {showPreview ? <RenderFile openDialog={showPreview} url={url} close={closePreview} /> : null}
        {showPreviewSuper ? <RenderFile openDialog={showPreviewSuper} url={urlSuper} close={closePreviewSuper} /> : null}
        <ModalProrroga
          openDialog={showProrroga}
          close={closeModalProrroga}
          reclamo={reclamoProrroga}
          reload={reload}
          setReload={setReload}
        />
        <QuitReclamo
          openDialog={showQuitarReclamo}
          close={quitarReclamoClose}
          reclamo={reclamoQuitar}
          submit={quitarReclamoSubmit}
        />

        {primeraCarga ? (
          entidadesList.length === 0 ? (
            <h1 style={{ marginLeft: 16 }}>Usted no tiene reclamos asignados</h1>
          ) : (
            <CustomTable
              headCells={tableHeadCells}
              rows={entidadesList}
              title={'Reclamos'}
              validation={validaciones}
              search={true}
              actions={misAsignacionesActions}
              handleAction={handleAction}
              openModal={openModal}
            />
          )
        ) : (
          <PageLoader />
        )}
      </Fragment>
    )
  );
};

export default TablaReclamosPendientes;
